
// // // // import React, { useState, useRef } from 'react';
// // // // import { postData } from '../../../../Services/Fetchnodeservices';
// // // // import { Image as ImageIcon, Trash2, Sparkles, X, Plus } from 'lucide-react';
// // // // import ImageSearchModal from './ImageSearchModal';

// // // // const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded }) => {
// // // //     const [step, setStep] = useState('upload'); 
// // // //     const [loadingStep, setLoadingStep] = useState("");
// // // //     const [selectedFile, setSelectedFile] = useState(null);
// // // //     const [previewUrl, setPreviewUrl] = useState("");
// // // //     const [scanResults, setScanResults] = useState([]);
// // // //     const [saving, setSaving] = useState(false);
// // // //     const [isBulkSearching, setIsBulkSearching] = useState(false);
// // // //     const [showImageFinder, setShowImageFinder] = useState(false);
// // // //     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
// // // //     const [searchQuery, setSearchQuery] = useState("");
// // // //     const fileInputRef = useRef(null);

// // // //     const getMarkup = (p) => {
// // // //         const m = parseFloat(p) || 0;
// // // //         const c = Math.round(m * 1.20);
// // // //         return { menu: m, cust: c, comm: c - m };
// // // //     };
// // // //     const getVariantMarkup = (p) => Math.round((parseFloat(p) || 0) * 1.20);

// // // //     // 🔥 MAGIC AUTO-FIND ALL IMAGES (Bulk Search) - RE-ADDED
// // // //     const autoFetchAllImages = async () => {
// // // //         setIsBulkSearching(true);
// // // //         const updated = [...scanResults];
// // // //         for (let i = 0; i < updated.length; i++) {
// // // //             try {
// // // //                 setLoadingStep(`Magic finding image for: ${updated[i].name}...`);
// // // //                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
// // // //                 if (resp.success && resp.images.length > 0) {
// // // //                     updated[i].pic1 = resp.images[0].url;
// // // //                     setScanResults([...updated]);
// // // //                 }
// // // //             } catch (e) { console.error(e); }
// // // //         }
// // // //         setIsBulkSearching(false);
// // // //         setLoadingStep("");
// // // //     };

// // // //     const startScan = async () => {
// // // //         if (!selectedFile) return;
// // // //         setStep('scanning');
// // // //         setLoadingStep("AI Analyzing Grid Menu (Multi-Price Columns)...");
// // // //         const formData = new FormData();
// // // //         formData.append("file", selectedFile);
// // // //         formData.append("designation_id", designationId);
// // // //         formData.append("instructions", "Identify all column headers such as Veg, Egg, Chicken, Prawns. For every row, capture the price for each column as a variant. Also provide a 10-word description for each dish.");

// // // //         try {
// // // //             const resp = await postData("aimenu/ai-scan", formData);
// // // //             if (resp.success) {
// // // //                 setScanResults(resp.new_items.map(i => ({ 
// // // //                     ...i, 
// // // //                     tempId: Math.random(), 
// // // //                     selected: true, 
// // // //                     variants: i.variants?.map(v => ({...v, price: v.price || v.item_price_variant})) || [],
// // // //                     description: i.description || "" 
// // // //                 })));
// // // //                 setStep('results');
// // // //             } else { setStep('upload'); }
// // // //         } catch (err) { setStep('upload'); }
// // // //     };

// // // //     const handleSaveItems = async () => {
// // // //         setSaving(true);
// // // //         const finalItems = scanResults.filter(i => i.selected).map(item => {
// // // //             const basePrice = parseFloat(item.price) || 0;
// // // //             const p = getMarkup(basePrice);
            
// // // //             const formattedVariants = (item.variants || []).map(v => {
// // // //                 const manualPrice = parseFloat(v.price) || 0;
// // // //                 return {
// // // //                     unit: (v.unit_value || "Price").toLowerCase(),
// // // //                     unit_value: v.unit_value || "Price",
// // // //                     item_price_variant: getVariantMarkup(manualPrice),
// // // //                     actual_price: manualPrice,
// // // //                     is_available_variant: "yes"
// // // //                 };
// // // //             });

// // // //             return { 
// // // //                 ...item, 
// // // //                 price: p.cust, 
// // // //                 requested_price: p.menu, 
// // // //                 status: "1", 
// // // //                 source: "ai_scan", 
// // // //                 variant: formattedVariants,
// // // //                 description: item.description 
// // // //             };
// // // //         });

// // // //         try {
// // // //             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
// // // //             if(resp.success) { onItemsAdded(); onClose(); }
// // // //         } catch (e) { console.error(e); }
// // // //         finally { setSaving(false); }
// // // //     };

// // // //     if (!isOpen) return null;

// // // //     return (
// // // //         <div style={styles.overlay} onClick={onClose}>
// // // //             <div style={styles.modal} onClick={e => e.stopPropagation()}>
// // // //                 <div style={styles.header}>
// // // //                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
// // // //                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
// // // //                         <h3 style={{margin:0, fontSize:'18px'}}>AI Grid Scan (Magic Image Enabled)</h3>
// // // //                     </div>
// // // //                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
// // // //                 </div>

// // // //                 <div style={styles.body}>
// // // //                     {step === 'upload' ? (
// // // //                         <div style={{textAlign:'center'}}>
// // // //                             <div style={styles.dropZone} onClick={() => fileInputRef.current.click()}>
// // // //                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
// // // //                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
// // // //                             </div>
// // // //                             <button style={styles.btnPrimary} onClick={startScan}>Start AI Scan</button>
// // // //                         </div>
// // // //                     ) : (step === 'scanning' || isBulkSearching) ? (
// // // //                         <div style={{textAlign:'center', padding:'80px'}}>
// // // //                             <div className="loader"></div>
// // // //                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
// // // //                         </div>
// // // //                     ) : (
// // // //                         <>
// // // //                             <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
// // // //                                 <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "Add All Items"}</button>
// // // //                                 <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> Magic Find All Images</button>
// // // //                             </div>
// // // //                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
// // // //                                 {scanResults.map((item, idx) => (
// // // //                                     <div key={item.tempId} style={styles.itemCard}>
// // // //                                         <div style={{display:'flex', gap:'15px'}}>
// // // //                                             <div style={{width:'80px'}}>
// // // //                                                 <img src={item.pic1?.startsWith('http') ? item.pic1 : `https://zaptodoor.com/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/80"} alt="dish" />
// // // //                                                 <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Find</button>
// // // //                                             </div>
// // // //                                             <div style={{flex:1}}>
// // // //                                                 <div style={{display:'flex', gap:'10px'}}>
// // // //                                                     <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
// // // //                                                     <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
// // // //                                                 </div>
// // // //                                                 <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
// // // //                                                 <div style={styles.variantBox}>
// // // //                                                     <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
// // // //                                                         {item.variants.map((v, vIdx) => (
// // // //                                                             <div key={vIdx} style={styles.vRow}>
// // // //                                                                 <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
// // // //                                                                 <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
// // // //                                                                 <span style={{color:'#10b981', fontSize:'11px'}}>₹{getVariantMarkup(v.price)}</span>
// // // //                                                                 <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={{background:'none', border:'none', color:'#f87171'}}><X size={12}/></button>
// // // //                                                             </div>
// // // //                                                         ))}
// // // //                                                         <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Add Price</button>
// // // //                                                     </div>
// // // //                                                 </div>
// // // //                                             </div>
// // // //                                         </div>
// // // //                                     </div>
// // // //                                 ))}
// // // //                             </div>
// // // //                         </>
// // // //                     )}
// // // //                 </div>
// // // //             </div>
// // // //             {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={img => { const nr=[...scanResults]; nr[currentSearchIndex].pic1=img; setScanResults(nr); setShowImageFinder(false); }} />}
// // // //             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
// // // //         </div>
// // // //     );
// // // // };

// // // // const styles = {
// // // //     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
// // // //     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
// // // //     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
// // // //     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
// // // //     body: { flex: 1, overflowY: 'auto', padding: '20px' },
// // // //     dropZone: { height: '160px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px' },
// // // //     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '10px', fontWeight: 600, cursor: 'pointer' },
// // // //     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
// // // //     thumb: { width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' },
// // // //     findBtn: { width: '100%', background: 'rgba(168, 85, 247, 0.1)', border: 'none', color: '#a855f7', fontSize: '10px', padding: '4px', borderRadius: '4px', marginTop: '5px', cursor: 'pointer' },
// // // //     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '16px', fontWeight: 600, flex: 1, outline: 'none' },
// // // //     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '11px', padding: '8px', marginTop: '8px', resize: 'none', outline: 'none' },
// // // //     variantBox: { background: '#161616', padding: '8px', borderRadius: '8px', marginTop: '8px' },
// // // //     vRow: { display: 'flex', alignItems: 'center', gap: '5px', background: '#0a0a0a', padding: '4px 8px', borderRadius: '6px', border: '1px solid #1f1f1f' },
// // // //     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '60px', fontSize: '11px', fontWeight: 'bold', outline: 'none' },
// // // //     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '50px', padding: '2px', textAlign: 'center', fontSize: '12px', outline: 'none' },
// // // //     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' },
// // // //     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' },
// // // //     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '10px', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer' },
// // // //     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '4px', fontSize: '12px' },
// // // //     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// // // // };

// // // // export default AIScanModal;

// // // import React, { useState, useRef, useEffect } from 'react';
// // // import { postData, getData } from '../../../../Services/Fetchnodeservices';
// // // import { Image as ImageIcon, Trash2, Sparkles, X, Plus, CloudUpload, History } from 'lucide-react';
// // // import ImageSearchModal from './ImageSearchModal';

// // // const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded }) => {
// // //     const [step, setStep] = useState('select-source'); // select-source, upload, vendor-images, scanning, results
// // //     const [loadingStep, setLoadingStep] = useState("");
// // //     const [selectedFile, setSelectedFile] = useState(null);
// // //     const [serverFileName, setServerFileName] = useState(""); // For images already on server
// // //     const [previewUrl, setPreviewUrl] = useState("");
// // //     const [scanResults, setScanResults] = useState([]);
// // //     const [vendorImages, setVendorImages] = useState([]);
// // //     const [loadingImages, setLoadingImages] = useState(false);
// // //     const [saving, setSaving] = useState(false);
// // //     const [isBulkSearching, setIsBulkSearching] = useState(false);
// // //     const [showImageFinder, setShowImageFinder] = useState(false);
// // //     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
// // //     const [searchQuery, setSearchQuery] = useState("");
// // //     const fileInputRef = useRef(null);

// // //     const getMarkup = (p) => {
// // //         const m = parseFloat(p) || 0;
// // //         const c = Math.round(m * 1.20);
// // //         return { menu: m, cust: c, comm: c - m };
// // //     };
// // //     const getVariantMarkup = (p) => Math.round((parseFloat(p) || 0) * 1.20);

// // //     // Fetch Vendor Images from Database
// // //     const fetchVendorImages = async () => {
// // //         setLoadingImages(true);
// // //         setStep('vendor-images');
// // //         try {
// // //             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
// // //             if (resp.success) {
// // //                 // Flattening multiple files into a single list
// // //                 const allFiles = [];
// // //                 resp.data.forEach(req => {
// // //                     req.files.forEach(f => {
// // //                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
// // //                     });
// // //                 });
// // //                 setVendorImages(allFiles);
// // //             }
// // //         } catch (e) { console.error(e); }
// // //         finally { setLoadingImages(false); }
// // //     };

// // //     const handleVendorImageSelect = (filename) => {
// // //         setServerFileName(filename);
// // //         setPreviewUrl(`https://zaptodoor.com/uploads/${filename}`);
// // //         setStep('upload'); // Go to confirm step
// // //     };

// // //     const autoFetchAllImages = async () => {
// // //         setIsBulkSearching(true);
// // //         const updated = [...scanResults];
// // //         for (let i = 0; i < updated.length; i++) {
// // //             try {
// // //                 setLoadingStep(`Magic finding image for: ${updated[i].name}...`);
// // //                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
// // //                 if (resp.success && resp.images.length > 0) {
// // //                     updated[i].pic1 = resp.images[0].url;
// // //                     setScanResults([...updated]);
// // //                 }
// // //             } catch (e) { console.error(e); }
// // //         }
// // //         setIsBulkSearching(false);
// // //         setLoadingStep("");
// // //     };

// // //     const startScan = async () => {
// // //         setStep('scanning');
// // //         setLoadingStep("AI Analyzing Menu Layout...");
// // //         const formData = new FormData();
        
// // //         if (selectedFile) {
// // //             formData.append("file", selectedFile);
// // //         } else {
// // //             formData.append("serverFileName", serverFileName);
// // //         }
        
// // //         formData.append("designation_id", designationId);
// // //         formData.append("instructions", "Identify all column headers like Veg, Egg, Chicken. For every row, capture price as variant. Provide 10-word description.");

// // //         try {
// // //             const resp = await postData("aimenu/ai-scan", formData);
// // //             if (resp.success) {
// // //                 setScanResults(resp.new_items.map(i => ({ 
// // //                     ...i, 
// // //                     tempId: Math.random(), 
// // //                     selected: true, 
// // //                     variants: i.variants?.map(v => ({...v, price: v.price || v.item_price_variant})) || [],
// // //                     description: i.description || "" 
// // //                 })));
// // //                 setStep('results');
// // //             } else { setStep('select-source'); }
// // //         } catch (err) { setStep('select-source'); }
// // //     };

// // //     const handleSaveItems = async () => {
// // //         setSaving(true);
// // //         const finalItems = scanResults.filter(i => i.selected).map(item => {
// // //             const basePrice = parseFloat(item.price) || 0;
// // //             const p = getMarkup(basePrice);
// // //             const formattedVariants = (item.variants || []).map(v => {
// // //                 const manualPrice = parseFloat(v.price) || 0;
// // //                 return {
// // //                     unit: (v.unit_value || "Price").toLowerCase(),
// // //                     unit_value: v.unit_value || "Price",
// // //                     item_price_variant: getVariantMarkup(manualPrice),
// // //                     actual_price: manualPrice,
// // //                     is_available_variant: "yes"
// // //                 };
// // //             });
// // //             return { ...item, price: p.cust, requested_price: p.menu, status: "1", source: "ai_scan", variant: formattedVariants, description: item.description };
// // //         });

// // //         try {
// // //             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
// // //             if(resp.success) { onItemsAdded(); onClose(); }
// // //         } catch (e) { console.error(e); }
// // //         finally { setSaving(false); }
// // //     };

// // //     if (!isOpen) return null;

// // //     return (
// // //         <div style={styles.overlay} onClick={onClose}>
// // //             <div style={styles.modal} onClick={e => e.stopPropagation()}>
// // //                 <div style={styles.header}>
// // //                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
// // //                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
// // //                         <h3 style={{margin:0, fontSize:'18px'}}>AI Menu Scanner - {restaurantName}</h3>
// // //                     </div>
// // //                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
// // //                 </div>

// // //                 <div style={styles.body}>
// // //                     {step === 'select-source' ? (
// // //                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px'}}>
// // //                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
// // //                                 <CloudUpload size={40} color="#a855f7" />
// // //                                 <h3>Upload New</h3>
// // //                                 <p>Select image from your computer</p>
// // //                             </div>
// // //                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
// // //                                 <History size={40} color="#3b82f6" />
// // //                                 <h3>Vendor Uploads</h3>
// // //                                 <p>Select from images sent by restaurant</p>
// // //                             </div>
// // //                         </div>
// // //                     ) : step === 'vendor-images' ? (
// // //                         <div>
// // //                             <button onClick={()=>setStep('select-source')} style={{color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px'}}>← Back</button>
// // //                             {loadingImages ? <div className="loader"></div> : (
// // //                                 <div style={styles.grid}>
// // //                                     {vendorImages.length > 0 ? vendorImages.map((img, i) => (
// // //                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
// // //                                             <img src={`https://zaptodoor.com/uploads/${img.name}`} alt="vendor-menu" />
// // //                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
// // //                                         </div>
// // //                                     )) : <p style={{textAlign:'center', width:'100%', color:'#64748b'}}>No images uploaded by vendor yet.</p>}
// // //                                 </div>
// // //                             )}
// // //                         </div>
// // //                     ) : step === 'upload' ? (
// // //                         <div style={{textAlign:'center'}}>
// // //                             <button onClick={()=>setStep('select-source')} style={{color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left'}}>← Back</button>
// // //                             <div style={{clear:'both'}}></div>
// // //                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
// // //                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
// // //                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
// // //                             </div>
// // //                             <button style={styles.btnPrimary} onClick={startScan}>Start AI Scan</button>
// // //                         </div>
// // //                     ) : (step === 'scanning' || isBulkSearching) ? (
// // //                         <div style={{textAlign:'center', padding:'80px'}}>
// // //                             <div className="loader"></div>
// // //                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
// // //                         </div>
// // //                     ) : (
// // //                         <>
// // //                             <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
// // //                                 <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "Add All Items"}</button>
// // //                                 <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> Magic Find All Images</button>
// // //                             </div>
// // //                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
// // //                                 {scanResults.map((item, idx) => (
// // //                                     <div key={item.tempId} style={styles.itemCard}>
// // //                                         <div style={{display:'flex', gap:'15px'}}>
// // //                                             <div style={{width:'80px'}}>
// // //                                                 <img src={item.pic1?.startsWith('http') ? item.pic1 : `https://zaptodoor.com/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/80"} alt="dish" />
// // //                                                 <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Find</button>
// // //                                             </div>
// // //                                             <div style={{flex:1}}>
// // //                                                 <div style={{display:'flex', gap:'10px'}}>
// // //                                                     <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
// // //                                                     <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
// // //                                                 </div>
// // //                                                 <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
// // //                                                 <div style={styles.variantBox}>
// // //                                                     <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
// // //                                                         {item.variants.map((v, vIdx) => (
// // //                                                             <div key={vIdx} style={styles.vRow}>
// // //                                                                 <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
// // //                                                                 <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
// // //                                                                 <span style={{color:'#10b981', fontSize:'11px'}}>₹{getVariantMarkup(v.price)}</span>
// // //                                                                 <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={{background:'none', border:'none', color:'#f87171'}}><X size={12}/></button>
// // //                                                             </div>
// // //                                                         ))}
// // //                                                         <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Add Price</button>
// // //                                                     </div>
// // //                                                 </div>
// // //                                             </div>
// // //                                         </div>
// // //                                     </div>
// // //                                 ))}
// // //                             </div>
// // //                         </>
// // //                     )}
// // //                 </div>
// // //             </div>
// // //             {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={img => { const nr=[...scanResults]; nr[currentSearchIndex].pic1=img; setScanResults(nr); setShowImageFinder(false); }} />}
// // //             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
// // //         </div>
// // //     );
// // // };

// // // const styles = {
// // //     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
// // //     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
// // //     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
// // //     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
// // //     body: { flex: 1, overflowY: 'auto', padding: '20px' },
// // //     sourceCard: { flex:1, maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s', ':hover': {borderColor:'#a855f7'}},
// // //     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
// // //     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
// // //     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616' },
// // //     dropZone: { height: '200px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px' },
// // //     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '10px', fontWeight: 600, cursor: 'pointer' },
// // //     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
// // //     thumb: { width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' },
// // //     findBtn: { width: '100%', background: 'rgba(168, 85, 247, 0.1)', border: 'none', color: '#a855f7', fontSize: '10px', padding: '4px', borderRadius: '4px', marginTop: '5px', cursor: 'pointer' },
// // //     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '16px', fontWeight: 600, flex: 1, outline: 'none' },
// // //     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '11px', padding: '8px', marginTop: '8px', resize: 'none', outline: 'none' },
// // //     variantBox: { background: '#161616', padding: '8px', borderRadius: '8px', marginTop: '8px' },
// // //     vRow: { display: 'flex', alignItems: 'center', gap: '5px', background: '#0a0a0a', padding: '4px 8px', borderRadius: '6px', border: '1px solid #1f1f1f' },
// // //     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '60px', fontSize: '11px', fontWeight: 'bold', outline: 'none' },
// // //     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '50px', padding: '2px', textAlign: 'center', fontSize: '12px', outline: 'none' },
// // //     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' },
// // //     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' },
// // //     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '10px', padding: '4px 8px', borderRadius: '6px', cursor: 'pointer' },
// // //     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '4px', fontSize: '12px' },
// // //     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// // // };

// // // export default AIScanModal;

// // import React, { useState, useRef, useEffect } from 'react';
// // import { postData, getData, serverURL } from '../../../../Services/Fetchnodeservices';
// // import { Image as ImageIcon, Trash2, Sparkles, X, Plus, CloudUpload, History } from 'lucide-react';
// // import ImageSearchModal from './ImageSearchModal';

// // const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded, preSelectedServerImage }) => {
// //     const [step, setStep] = useState('select-source'); // select-source, upload, vendor-images, scanning, results
// //     const [loadingStep, setLoadingStep] = useState("");
// //     const [selectedFile, setSelectedFile] = useState(null);
// //     const [serverFileName, setServerFileName] = useState(""); 
// //     const [previewUrl, setPreviewUrl] = useState("");
// //     const [scanResults, setScanResults] = useState([]);
// //     const [vendorImages, setVendorImages] = useState([]);
// //     const [loadingImages, setLoadingImages] = useState(false);
// //     const [saving, setSaving] = useState(false);
// //     const [isBulkSearching, setIsBulkSearching] = useState(false);
// //     const [showImageFinder, setShowImageFinder] = useState(false);
// //     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const fileInputRef = useRef(null);

// //     // 🔥 Effect to handle image passed from Admin Dashboard
// //     useEffect(() => {
// //         if (isOpen && preSelectedServerImage) {
// //             setServerFileName(preSelectedServerImage);
// //             setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
// //             setStep('upload'); // Confirm step par bhej do
// //         } else if (isOpen) {
// //             setStep('select-source');
// //             setServerFileName("");
// //             setSelectedFile(null);
// //             setPreviewUrl("");
// //         }
// //     }, [isOpen, preSelectedServerImage]);

// //     const getMarkup = (p) => {
// //         const m = parseFloat(p) || 0;
// //         const c = Math.round(m * 1.20);
// //         return { menu: m, cust: c, comm: c - m };
// //     };
// //     const getVariantMarkup = (p) => Math.round((parseFloat(p) || 0) * 1.20);

// //     const fetchVendorImages = async () => {
// //         setLoadingImages(true);
// //         setStep('vendor-images');
// //         try {
// //             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
// //             if (resp.success) {
// //                 const allFiles = [];
// //                 resp.data.forEach(req => {
// //                     req.files.forEach(f => {
// //                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
// //                     });
// //                 });
// //                 setVendorImages(allFiles);
// //             }
// //         } catch (e) { console.error(e); }
// //         finally { setLoadingImages(false); }
// //     };

// //     const handleVendorImageSelect = (filename) => {
// //         setServerFileName(filename);
// //         setPreviewUrl(`${serverURL}/uploads/${filename}`);
// //         setStep('upload');
// //     };

// //     const startScan = async () => {
// //         setStep('scanning');
// //         setLoadingStep("AI Analyzing Menu Layout...");
// //         const formData = new FormData();
        
// //         if (selectedFile) {
// //             formData.append("file", selectedFile);
// //         } else {
// //             formData.append("serverFileName", serverFileName);
// //         }
        
// //         formData.append("designation_id", designationId);
// //         formData.append("instructions", "Identify all column headers like Veg, Egg, Chicken. Capture prices as variants. Provide 10-word description.");

// //         try {
// //             const resp = await postData("aimenu/ai-scan", formData);
// //             if (resp.success) {
// //                 setScanResults(resp.new_items.map(i => ({ 
// //                     ...i, 
// //                     tempId: Math.random(), 
// //                     selected: true, 
// //                     variants: i.variants?.map(v => ({...v, price: v.price || v.item_price_variant})) || [],
// //                     description: i.description || "" 
// //                 })));
// //                 setStep('results');
// //             } else { setStep('select-source'); }
// //         } catch (err) { setStep('select-source'); }
// //     };

// //     const handleSaveItems = async () => {
// //         setSaving(true);
// //         const finalItems = scanResults.filter(i => i.selected).map(item => {
// //             const basePrice = parseFloat(item.price) || 0;
// //             const p = getMarkup(basePrice);
// //             const formattedVariants = (item.variants || []).map(v => {
// //                 const manualPrice = parseFloat(v.price) || 0;
// //                 return {
// //                     unit: (v.unit_value || "Price").toLowerCase(),
// //                     unit_value: v.unit_value || "Price",
// //                     item_price_variant: getVariantMarkup(manualPrice),
// //                     actual_price: manualPrice,
// //                     is_available_variant: "yes"
// //                 };
// //             });
// //             return { ...item, price: p.cust, requested_price: p.menu, status: "1", source: "ai_scan", variant: formattedVariants, description: item.description };
// //         });

// //         try {
// //             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
// //             if(resp.success) { onItemsAdded(); onClose(); }
// //         } catch (e) { console.error(e); }
// //         finally { setSaving(false); }
// //     };

// //     if (!isOpen) return null;

// //     return (
// //         <div style={styles.overlay} onClick={onClose}>
// //             <div style={styles.modal} onClick={e => e.stopPropagation()}>
// //                 <div style={styles.header}>
// //                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
// //                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
// //                         <h3 style={{margin:0, fontSize:'18px'}}>AI Menu Scanner - {restaurantName}</h3>
// //                     </div>
// //                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
// //                 </div>

// //                 <div style={styles.body}>
// //                     {step === 'select-source' ? (
// //                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
// //                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
// //                                 <CloudUpload size={40} color="#a855f7" />
// //                                 <h3 style={{color: 'white'}}>Upload New</h3>
// //                                 <p style={{color: '#94a3b8'}}>Select image from your computer</p>
// //                             </div>
// //                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
// //                                 <History size={40} color="#3b82f6" />
// //                                 <h3 style={{color: 'white'}}>Vendor Uploads</h3>
// //                                 <p style={{color: '#94a3b8'}}>Select from images sent by restaurant</p>
// //                             </div>
// //                         </div>
// //                     ) : step === 'vendor-images' ? (
// //                         <div>
// //                             <button onClick={()=>setStep('select-source')} style={{color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', display:'flex', alignItems:'center', gap:'5px'}}>← Back to Source</button>
// //                             {loadingImages ? <div className="loader"></div> : (
// //                                 <div style={styles.grid}>
// //                                     {vendorImages.length > 0 ? vendorImages.map((img, i) => (
// //                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
// //                                             <img src={`${serverURL}/uploads/${img.name}`} alt="vendor-menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
// //                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
// //                                         </div>
// //                                     )) : <p style={{textAlign:'center', width:'100%', color:'#64748b'}}>No images uploaded by vendor yet.</p>}
// //                                 </div>
// //                             )}
// //                         </div>
// //                     ) : step === 'upload' ? (
// //                         <div style={{textAlign:'center'}}>
// //                             <button onClick={()=>setStep('select-source')} style={{color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left'}}>← Change Source</button>
// //                             <div style={{clear:'both'}}></div>
// //                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
// //                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
// //                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
// //                             </div>
// //                             <button style={styles.btnPrimary} onClick={startScan}>Start AI Scan</button>
// //                         </div>
// //                     ) : (step === 'scanning') ? (
// //                         <div style={{textAlign:'center', padding:'80px'}}>
// //                             <div className="loader"></div>
// //                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
// //                         </div>
// //                     ) : (
// //                         <>
// //                             <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
// //                                 <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "Add All Items"}</button>
// //                             </div>
// //                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
// //                                 {scanResults.map((item, idx) => (
// //                                     <div key={item.tempId} style={styles.itemCard}>
// //                                         <div style={{display:'flex', gap:'15px'}}>
// //                                             <div style={{width:'80px'}}>
// //                                                 <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/80"} alt="dish" />
// //                                             </div>
// //                                             <div style={{flex:1}}>
// //                                                 <div style={{display:'flex', gap:'10px'}}>
// //                                                     <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
// //                                                     <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
// //                                                 </div>
// //                                                 <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
// //                                                 <div style={styles.variantBox}>
// //                                                     <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
// //                                                         {item.variants.map((v, vIdx) => (
// //                                                             <div key={vIdx} style={styles.vRow}>
// //                                                                 <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
// //                                                                 <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
// //                                                                 <span style={{color:'#10b981', fontSize:'11px'}}>₹{getVariantMarkup(v.price)}</span>
// //                                                             </div>
// //                                                         ))}
// //                                                     </div>
// //                                                 </div>
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                 ))}
// //                             </div>
// //                         </>
// //                     )}
// //                 </div>
// //             </div>
// //             {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={img => { const nr=[...scanResults]; nr[currentSearchIndex].pic1=img; setScanResults(nr); setShowImageFinder(false); }} />}
// //             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
// //         </div>
// //     );
// // };

// // const styles = {
// //     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
// //     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
// //     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
// //     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
// //     body: { flex: 1, overflowY: 'auto', padding: '20px' },
// //     sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
// //     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
// //     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
// //     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
// //     dropZone: { height: '240px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow: 'hidden' },
// //     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '10px', fontWeight: 600, cursor: 'pointer' },
// //     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
// //     thumb: { width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' },
// //     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '16px', fontWeight: 600, flex: 1, outline: 'none' },
// //     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '11px', padding: '8px', marginTop: '8px', resize: 'none', outline: 'none' },
// //     variantBox: { background: '#161616', padding: '8px', borderRadius: '8px', marginTop: '8px' },
// //     vRow: { display: 'flex', alignItems: 'center', gap: '5px', background: '#0a0a0a', padding: '4px 8px', borderRadius: '6px', border: '1px solid #1f1f1f' },
// //     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '60px', fontSize: '11px', fontWeight: 'bold', outline: 'none' },
// //     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '50px', padding: '2px', textAlign: 'center', fontSize: '12px', outline: 'none' },
// //     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' },
// //     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '4px', fontSize: '12px' },
// //     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// // };

// // export default AIScanModal;

// import React, { useState, useRef, useEffect } from 'react';
// import { postData, getData, serverURL } from '../../../../Services/Fetchnodeservices';
// import { Image as ImageIcon, Trash2, Sparkles, X, Plus, CloudUpload, History, Search, ListCheck } from 'lucide-react';
// import ImageSearchModal from './ImageSearchModal';

// const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded, preSelectedServerImage }) => {
//     const [step, setStep] = useState('select-source'); // select-source, upload, vendor-images, scanning, results
//     const [loadingStep, setLoadingStep] = useState("");
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [serverFileName, setServerFileName] = useState(""); 
//     const [previewUrl, setPreviewUrl] = useState("");
//     const [scanResults, setScanResults] = useState([]);
//     const [vendorImages, setVendorImages] = useState([]);
//     const [loadingImages, setLoadingImages] = useState(false);
//     const [saving, setSaving] = useState(false);
//     const [isBulkSearching, setIsBulkSearching] = useState(false);
//     const [showImageFinder, setShowImageFinder] = useState(false);
//     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const fileInputRef = useRef(null);

//     // Initial setup on open
//     useEffect(() => {
//         if (isOpen) {
//             if (preSelectedServerImage) {
//                 setServerFileName(preSelectedServerImage);
//                 setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
//                 setStep('upload'); 
//             } else {
//                 setStep('select-source');
//                 setServerFileName("");
//                 setSelectedFile(null);
//                 setPreviewUrl("");
//             }
//             setScanResults([]);
//         }
//     }, [isOpen, preSelectedServerImage]);

//     const getMarkup = (p) => {
//         const m = parseFloat(p) || 0;
//         const c = Math.round(m * 1.20);
//         return { menu: m, cust: c, comm: c - m };
//     };
//     const getVariantMarkup = (p) => Math.round((parseFloat(p) || 0) * 1.20);

//     // 🔥 MAGIC AUTO-FIND ALL IMAGES
//     const autoFetchAllImages = async () => {
//         setIsBulkSearching(true);
//         const updated = [...scanResults];
//         for (let i = 0; i < updated.length; i++) {
//             try {
//                 setLoadingStep(`Magic finding image for: ${updated[i].name}...`);
//                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
//                 if (resp.success && resp.images.length > 0) {
//                     updated[i].pic1 = resp.images[0].url;
//                     setScanResults([...updated]);
//                 }
//             } catch (e) { console.error(e); }
//         }
//         setIsBulkSearching(false);
//         setLoadingStep("");
//     };

//     const fetchVendorImages = async () => {
//         setLoadingImages(true);
//         setStep('vendor-images');
//         try {
//             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
//             if (resp.success) {
//                 const allFiles = [];
//                 resp.data.forEach(req => {
//                     const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
//                     files.forEach(f => {
//                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
//                     });
//                 });
//                 setVendorImages(allFiles);
//             }
//         } catch (e) { console.error(e); }
//         finally { setLoadingImages(false); }
//     };

//     const handleVendorImageSelect = (filename) => {
//         setServerFileName(filename);
//         setPreviewUrl(`${serverURL}/uploads/${filename}`);
//         setStep('upload');
//     };

//     const startScan = async () => {
//         setStep('scanning');
//         setLoadingStep("AI Analyzing Menu Layout...");
//         const formData = new FormData();
//         if (selectedFile) formData.append("file", selectedFile);
//         else formData.append("serverFileName", serverFileName);
        
//         formData.append("designation_id", designationId);
//         formData.append("instructions", "Identify all columns like Veg, Egg, Chicken. Capture prices as variants. Provide 10-word description.");

//         try {
//             const resp = await postData("aimenu/ai-scan", formData);
//             if (resp.success) {
//                 setScanResults(resp.new_items.map(i => ({ 
//                     ...i, 
//                     tempId: Math.random().toString(36).substr(2, 9), 
//                     selected: true, 
//                     variants: i.variants?.map(v => ({...v, price: v.price || v.item_price_variant})) || [],
//                     description: i.description || "" 
//                 })));
//                 setStep('results');
//             } else { setStep('select-source'); }
//         } catch (err) { setStep('select-source'); }
//     };

//     const handleSaveItems = async () => {
//         setSaving(true);
//         const finalItems = scanResults.filter(i => i.selected).map(item => {
//             const basePrice = parseFloat(item.price) || 0;
//             const p = getMarkup(basePrice);
//             const formattedVariants = (item.variants || []).map(v => {
//                 const manualPrice = parseFloat(v.price) || 0;
//                 return {
//                     unit: (v.unit_value || "Price").toLowerCase(),
//                     unit_value: v.unit_value || "Price",
//                     item_price_variant: getVariantMarkup(manualPrice),
//                     actual_price: manualPrice,
//                     is_available_variant: "yes"
//                 };
//             });
//             return { ...item, price: p.cust, requested_price: p.menu, status: "1", source: "ai_scan", variant: formattedVariants, description: item.description };
//         });

//         try {
//             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
//             if(resp.success) { onItemsAdded(); onClose(); }
//         } catch (e) { console.error(e); }
//         finally { setSaving(false); }
//     };

//     // 🔥 STABLE IMAGE SELECTION (CRASH FIXED)
//     const handleImageSelect = (imgUrl) => {
//         if (currentSearchIndex !== null) {
//             setScanResults(prev => {
//                 const updated = [...prev];
//                 if(updated[currentSearchIndex]) {
//                     updated[currentSearchIndex].pic1 = imgUrl;
//                 }
//                 return updated;
//             });
//         }
//         setShowImageFinder(false);
//     };

//     if (!isOpen) return null;

//     return (
//         <div style={styles.overlay} onClick={onClose}>
//             <div style={styles.modal} onClick={e => e.stopPropagation()}>
//                 <div style={styles.header}>
//                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
//                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
//                         <h3 style={{margin:0, fontSize:'18px'}}>AI Scanner - {restaurantName}</h3>
//                     </div>
//                     {scanResults.length > 0 && (
//                         <div style={styles.countBadge}>
//                             <ListCheck size={14} /> Total Items: {scanResults.length}
//                         </div>
//                     )}
//                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
//                 </div>

//                 <div style={styles.body}>
//                     {step === 'select-source' ? (
//                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
//                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
//                                 <CloudUpload size={40} color="#a855f7" />
//                                 <h3 style={{color:'white'}}>Upload File</h3>
//                                 <p style={{color:'#94a3b8'}}>From local computer/mobile</p>
//                             </div>
//                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
//                                 <History size={40} color="#3b82f6" />
//                                 <h3 style={{color:'white'}}>Vendor Menu</h3>
//                                 <p style={{color:'#94a3b8'}}>Browse restaurant uploads</p>
//                             </div>
//                         </div>
//                     ) : step === 'vendor-images' ? (
//                         <div>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back to Sources</button>
//                             {loadingImages ? <div className="loader"></div> : (
//                                 <div style={styles.grid}>
//                                     {vendorImages.map((img, i) => (
//                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
//                                             <img src={`${serverURL}/uploads/${img.name}`} alt="v-menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
//                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     ) : step === 'upload' ? (
//                         <div style={{textAlign:'center'}}>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change Source</button>
//                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
//                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
//                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
//                             </div>
//                             <button style={styles.btnPrimary} onClick={startScan}>Start AI Scan</button>
//                         </div>
//                     ) : (step === 'scanning' || isBulkSearching) ? (
//                         <div style={{textAlign:'center', padding:'80px'}}>
//                             <div className="loader"></div>
//                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
//                         </div>
//                     ) : (
//                         <>
//                             <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
//                                 <div style={{display:'flex', gap:'10px'}}>
//                                     <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "Add Scanned Items"}</button>
//                                     <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> Magic Find Images</button>
//                                 </div>
//                                 <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} dishes detected</div>
//                             </div>
//                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
//                                 {scanResults.map((item, idx) => (
//                                     <div key={item.tempId} style={styles.itemCard}>
//                                         <div style={{display:'flex', gap:'15px'}}>
//                                             <div style={{width:'110px', textAlign:'center'}}>
//                                                 <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/100"} alt="dish" />
//                                                 <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
//                                             </div>
//                                             <div style={{flex:1}}>
//                                                 <div style={{display:'flex', gap:'10px'}}>
//                                                     <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
//                                                     <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
//                                                 </div>
//                                                 <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
                                                
//                                                 <div style={styles.variantBox}>
//                                                     <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
//                                                         {item.variants.map((v, vIdx) => (
//                                                             <div key={vIdx} style={styles.vRow}>
//                                                                 <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
//                                                                 <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
//                                                                 <span style={{color:'#10b981', fontSize:'11px'}}>₹{getVariantMarkup(v.price)}</span>
//                                                                 <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
//                                                             </div>
//                                                         ))}
//                                                         <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Price</button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>
//             {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={handleImageSelect} />}
//             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
//         </div>
//     );
// };

// const styles = {
//     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
//     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
//     countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
//     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
//     body: { flex: 1, overflowY: 'auto', padding: '20px' },
//     backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
//     backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
//     sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
//     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
//     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
//     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
//     dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
//     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
//     thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
//     findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
//     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
//     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
//     variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
//     vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
//     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
//     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '60px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
//     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
//     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
//     delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
//     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
//     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// };

// export default AIScanModal;

import React, { useState, useRef, useEffect } from 'react';
import { postData, getData, serverURL } from '../../../../Services/Fetchnodeservices';
import { Image as ImageIcon, Trash2, Sparkles, X, Plus, CloudUpload, History, Search, ListCheck } from 'lucide-react';
import ImageSearchModal from './ImageSearchModal';

const AIScanModal = ({ isOpen, onClose, designationId, restaurantName, onItemsAdded, preSelectedServerImage }) => {
    const [step, setStep] = useState('select-source');
    const [loadingStep, setLoadingStep] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [serverFileName, setServerFileName] = useState(""); 
    const [previewUrl, setPreviewUrl] = useState("");
    const [scanResults, setScanResults] = useState([]);
    const [vendorImages, setVendorImages] = useState([]);
    const [loadingImages, setLoadingImages] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isBulkSearching, setIsBulkSearching] = useState(false);
    const [showImageFinder, setShowImageFinder] = useState(false);
    const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            if (preSelectedServerImage) {
                setServerFileName(preSelectedServerImage);
                setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
                setStep('upload'); 
            } else {
                setStep('select-source');
                setServerFileName("");
                setSelectedFile(null);
                setPreviewUrl("");
            }
            setScanResults([]);
        }
    }, [isOpen, preSelectedServerImage]);

    const getMarkup = (p) => {
        const m = parseFloat(p) || 0;
        const c = Math.round(m * 1.20);
        return { menu: m, cust: c, comm: c - m };
    };
    const getVariantMarkup = (p) => Math.round((parseFloat(p) || 0) * 1.20);

    const autoFetchAllImages = async () => {
        setIsBulkSearching(true);
        const updated = [...scanResults];
        for (let i = 0; i < updated.length; i++) {
            try {
                setLoadingStep(`Magic finding image for: ${updated[i].name}...`);
                const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
                if (resp.success && resp.images.length > 0) {
                    updated[i].pic1 = resp.images[0].url;
                    setScanResults([...updated]);
                }
            } catch (e) { console.error(e); }
        }
        setIsBulkSearching(false);
        setLoadingStep("");
    };

    const fetchVendorImages = async () => {
        setLoadingImages(true);
        setStep('vendor-images');
        try {
            const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
            if (resp.success) {
                const allFiles = [];
                resp.data.forEach(req => {
                    const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
                    files.forEach(f => {
                        if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
                    });
                });
                setVendorImages(allFiles);
            }
        } catch (e) { console.error(e); }
        finally { setLoadingImages(false); }
    };

    const handleVendorImageSelect = (filename) => {
        setServerFileName(filename);
        setPreviewUrl(`${serverURL}/uploads/${filename}`);
        setStep('upload');
    };

    const startScan = async () => {
        setStep('scanning');
        setLoadingStep("AI Analyzing Menu Layout...");
        const formData = new FormData();
        if (selectedFile) formData.append("file", selectedFile);
        else formData.append("serverFileName", serverFileName);
        
        formData.append("designation_id", designationId);
        formData.append("instructions", "Identify all columns like Veg, Egg, Chicken. Capture prices as variants. Provide 10-word description.");

        try {
            const resp = await postData("aimenu/ai-scan", formData);
            if (resp.success) {
                setScanResults(resp.new_items.map(i => ({ 
                    ...i, 
                    tempId: Math.random().toString(36).substr(2, 9), 
                    selected: true, 
                    variants: i.variants?.map(v => ({...v, price: v.price || v.item_price_variant})) || [],
                    description: i.description || "" 
                })));
                setStep('results');
            } else { setStep('select-source'); }
        } catch (err) { setStep('select-source'); }
    };

    const handleSaveItems = async () => {
        setSaving(true);
        const finalItems = scanResults.filter(i => i.selected).map(item => {
            const basePrice = parseFloat(item.price) || 0;
            const p = getMarkup(basePrice);
            const formattedVariants = (item.variants || []).map(v => {
                const manualPrice = parseFloat(v.price) || 0;
                return {
                    unit: (v.unit_value || "Price").toLowerCase(),
                    unit_value: v.unit_value || "Price",
                    item_price_variant: getVariantMarkup(manualPrice),
                    actual_price: manualPrice,
                    is_available_variant: "yes"
                };
            });
            return { ...item, price: p.cust, requested_price: p.menu, status: "1", source: "ai_scan", variant: formattedVariants, description: item.description };
        });

        try {
            const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
            if(resp.success) { onItemsAdded(); onClose(); }
        } catch (e) { console.error(e); }
        finally { setSaving(false); }
    };

    // 🔥 FIXED: Image selection – no extra side effects
    const handleImageSelect = (imgUrl) => {
        if (currentSearchIndex !== null) {
            setScanResults(prev => {
                const updated = [...prev];
                if(updated[currentSearchIndex]) {
                    updated[currentSearchIndex].pic1 = imgUrl;
                }
                return updated;
            });
        }
        setShowImageFinder(false);
    };

    if (!isOpen) return null;

    return (
        <div 
            style={styles.overlay} 
            // 🔥 CRITICAL FIX: Agar ImageSearchModal open hai, toh overlay click se modal band mat karo
            onClick={showImageFinder ? undefined : onClose}
        >
            <div style={styles.modal} onClick={e => e.stopPropagation()}>
                <div style={styles.header}>
                    <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
                        <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
                        <h3 style={{margin:0, fontSize:'18px'}}>AI Scanner - {restaurantName}</h3>
                    </div>
                    {scanResults.length > 0 && (
                        <div style={styles.countBadge}>
                            <ListCheck size={14} /> Total Items: {scanResults.length}
                        </div>
                    )}
                    <button onClick={onClose} style={styles.closeBtn}><X /></button>
                </div>

                <div style={styles.body}>
                    {step === 'select-source' ? (
                        <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
                            <div style={styles.sourceCard} onClick={() => setStep('upload')}>
                                <CloudUpload size={40} color="#a855f7" />
                                <h3 style={{color:'white'}}>Upload File</h3>
                                <p style={{color:'#94a3b8'}}>From local computer/mobile</p>
                            </div>
                            <div style={styles.sourceCard} onClick={fetchVendorImages}>
                                <History size={40} color="#3b82f6" />
                                <h3 style={{color:'white'}}>Vendor Menu</h3>
                                <p style={{color:'#94a3b8'}}>Browse restaurant uploads</p>
                            </div>
                        </div>
                    ) : step === 'vendor-images' ? (
                        <div>
                            <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back to Sources</button>
                            {loadingImages ? <div className="loader"></div> : (
                                <div style={styles.grid}>
                                    {vendorImages.map((img, i) => (
                                        <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
                                            <img src={`${serverURL}/uploads/${img.name}`} alt="v-menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
                                            <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ) : step === 'upload' ? (
                        <div style={{textAlign:'center'}}>
                            <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change Source</button>
                            <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
                                <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
                                {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
                            </div>
                            <button style={styles.btnPrimary} onClick={startScan}>Start AI Scan</button>
                        </div>
                    ) : (step === 'scanning' || isBulkSearching) ? (
                        <div style={{textAlign:'center', padding:'80px'}}>
                            <div className="loader"></div>
                            <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
                        </div>
                    ) : (
                        <>
                            <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
                                <div style={{display:'flex', gap:'10px'}}>
                                    <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "Add Scanned Items"}</button>
                                    <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> Magic Find Images</button>
                                </div>
                                <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} dishes detected</div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                                {scanResults.map((item, idx) => (
                                    <div key={item.tempId} style={styles.itemCard}>
                                        <div style={{display:'flex', gap:'15px'}}>
                                            <div style={{width:'110px', textAlign:'center'}}>
                                                <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.thumb} onError={e=>e.target.src="https://via.placeholder.com/100"} alt="dish" />
                                                <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
                                            </div>
                                            <div style={{flex:1}}>
                                                <div style={{display:'flex', gap:'10px'}}>
                                                    <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
                                                    <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
                                                </div>
                                                <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />
                                                
                                                <div style={styles.variantBox}>
                                                    <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
                                                        {item.variants.map((v, vIdx) => (
                                                            <div key={vIdx} style={styles.vRow}>
                                                                <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
                                                                <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; setScanResults(nr)}} />
                                                                <span style={{color:'#10b981', fontSize:'11px'}}>₹{getVariantMarkup(v.price)}</span>
                                                                <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
                                                            </div>
                                                        ))}
                                                        <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0}); setScanResults(nr)}}>+ Price</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* 🔥 EXTRA SAFETY: ImageSearchModal ke andar click ko parent tak pahunchne se roko */}
            {showImageFinder && (
                <div onClick={e => e.stopPropagation()} style={{ position: 'relative', zIndex: 10000 }}>
                    <ImageSearchModal 
                        isOpen={showImageFinder} 
                        onClose={() => setShowImageFinder(false)} 
                        query={searchQuery} 
                        onSelect={handleImageSelect} 
                    />
                </div>
            )}
            <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
    countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
    aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
    body: { flex: 1, overflowY: 'auto', padding: '20px' },
    backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
    backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
    sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
    grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
    imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
    imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
    dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
    btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
    itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
    thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
    findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
    inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
    inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
    variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
    vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
    inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
    inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '60px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
    btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
    btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
    addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
    delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
    typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
    closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
};

export default AIScanModal;